import { UserImportDataSourceIdentifier } from '@dadohr/shared/domainTypes/user';
import { useMemo } from 'react';
import { Color, ColoredChip } from '../../../../../components/ColoredChip';
import { TFunction, useTranslation } from '../../../../../i18next';
import { getUserImportSourceNameFromIdentifier } from '../../../../../services/user/import';

const getConfig = (
  identifier: UserImportDataSourceIdentifier,
  t: TFunction
): [string, Color] => {
  return [getUserImportSourceNameFromIdentifier(identifier), 'gray'];
};

export const ImportSourceChip = ({
  identifier,
  size
}: {
  identifier: UserImportDataSourceIdentifier;
  size?: 'small' | 'medium';
}) => {
  const { t } = useTranslation();

  const [label, color] = useMemo(() => getConfig(identifier, t), [
    identifier,
    t
  ]);

  const inactive = identifier.isInactive ? {opacity: 0.5} : {};

  return (
    <div style={inactive}>
      <ColoredChip color={color} size={size}>
        {label}
      </ColoredChip>
    </div>
  );
};
